// src/app/features/helpLoan/helpLoanApi.js
import http from "../../api/http.js";

/**
 * Create a presigned upload for HelpLoan documents.
 * Expected backend:
 * POST /help-loans/uploads/presign
 * body: { fileName: string, mimeType: string }
 * returns: { upload_url, s3_key, expires_in, file_url? }
 */
export async function presignHelpLoanUpload({ fileName, mimeType }) {
  const res = await http.post("/help-loans/uploads/presign", { fileName, mimeType });
  return res.data;
}

/**
 * Upload file directly to S3 using presigned PUT url.
 * Note: do NOT use axios instance (it adds auth headers, baseURL, etc).
 */
export async function uploadToPresignedUrl(uploadUrl, file) {
  const res = await fetch(uploadUrl, {
    method: "PUT",
    headers: {
      "Content-Type": file.type || "application/octet-stream",
    },
    body: file,
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`Upload failed (${res.status}). ${text}`);
  }
  return true;
}

/**
 * Create a HelpLoan application.
 * Expected backend:
 * POST /help-loans/applications
 * body: {
 *  propertyDetails: {...},
 *  incomeDetails: {..., incomeFileKey, incomeFileUrl?},
 *  bankDetails: {..., bankProofFileKey, bankProofFileUrl?},
 *  loanDetails: {...}
 * }
 * returns: { applicationId, status }
 */
export async function createHelpLoanApplication(payload) {
  const res = await http.post("/help-loans/applications", payload);
  return res.data;
}

/**
 * Get my applications (optional but recommended)
 * GET /help-loans/applications
 */
export async function getMyHelpLoanApplications(params = {}) {
  const res = await http.get("/help-loans/applications", { params });
  return res.data;
}

/**
 * Get application by id (optional)
 * GET /help-loans/applications/{applicationId}
 */
export async function getHelpLoanApplication(applicationId) {
  const res = await http.get(`/help-loans/applications/${applicationId}`);
  return res.data;
}
